import { render, staticRenderFns } from "./ModalSort.vue?vue&type=template&id=dc988292&scoped=true"
import script from "./ModalSort.vue?vue&type=script&lang=js"
export * from "./ModalSort.vue?vue&type=script&lang=js"
import style0 from "./ModalSort.vue?vue&type=style&index=0&id=dc988292&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc988292",
  null
  
)

export default component.exports